<template>
	<main class="vx-row">
		<div class="vx-col w-full">
			<vx-card>
				<div >
					<img :src="imageLink(data)" alt="Banner" class="responsive card-img-top" />
				</div>
				<!-- Nama -->
				<section class="my-6 mx-4">
					<h2 class="mb-6"><strong>{{data.name}}</strong></h2>
					<div class="flex justify-between mb-4">
						<div class="flex items-center">
							<feather-icon svgClasses="mr-4" icon="UserIcon"></feather-icon>
							<strong class="text-primary">{{ data.user ? data.user.name : '-' }}</strong>
						</div>
						<div v-if="data.hewan" class="flex items-center">
							<img v-if="[sapiCode, '1'].includes(data.hewan.toString().toLowerCase())" :src="`/assets/images/qurban/cow.png`" alt="" class="w-8 mr-2" />
							<img v-else :src="`/assets/images/qurban/sheep.png`" alt="" class="w-8 mr-2" />
							<strong>{{ capitalize( getAnimalName(data.hewan.toString().toLowerCase()) ) }}</strong>
						</div>
					</div>

					<!--  -->
					<div class="flex justify-between items-center mb-6">
						<div class="flex items-center">
							<h3 class="text-warning mb-2"><strong>Rp {{ formatRupiah(data.nominal) }}</strong></h3>
							<p class="text-left ml-2">/bagian</p>
						</div>
						
						<div>
							<h5 class="text-right"><strong>
								berat: {{ data.berat }}
							</strong></h5>
						</div>
						
					</div>
					<!-- / -->

					<div class="mb-4">
						<share-social-media
							:link="qurbanLink()"
							:name="qurbanName()"
							:types="[{name: 'whatsapp', style: {backgroundColor: '#25D366'} }, {name: 'facebook', style: {backgroundColor: '#4267B2'}}]"
							:description="qurbanDescription()"
						/>
					</div>

					<!-- Donasi skarang -->
					<vs-button @click.prevent="getCheckout" class="w-full">
						<strong class="text-warning">Ayo Berqurban</strong>
					</vs-button>
					<!-- / -->
				</section>
				
				<vs-divider></vs-divider>
				<section class="mb-12 mx-4">
					<h4 class="mb-4">Deskripsi Qurban</h4>
					<div class="text-center" v-if="!data.description">
						<span class="text-grey">Deskripsi Hewan Qurban.</span>
					</div>
					<div v-else v-html="data.description"></div>
				</section>
				<!-- / -->
				
				<!-- Other Qurban -->
                <other-qurban :datas="otherQurbans">
                    <template #header>
                        <section class="flex justify-between w-full items-center mb-4">
                            <h5 class="mr-6"><strong class="text-primary">Qurban Lainnya</strong></h5>
                            <router-link to="/zxcare/qurban" class="text-primary">
                                <small>Lihat Semua &nbsp;&nbsp;&nbsp;>></small>
                            </router-link>
                        </section>
                    </template>
                </other-qurban>
                <!-- / -->
				
			</vx-card>
		</div>
	</main>
</template>
<script>
import { mapState } from 'vuex';
import defaultImage from '@/assets/images/loading.gif';
import { PMRole } from '@/assets/utils/user_roles';
import {PMCode} from '@/assets/utils/campaign';

const sapiCode = 'sapi';

let meta = [
	{ property: 'og:url', content: process.env.VUE_APP_FE },
	{ property: 'og:type', content: 'website' },
	{ property: 'og:title', content: 'Website Zakat Express' },
	{ property: 'og:image', content: '/zx.png' },
	{ property: 'og:description', content: '-' }
];

export default {
	metaInfo: {
		meta
	},
    components: {
        OtherQurban: () => import('./components/QurbanCarousel.vue'),
		ShareSocialMedia: () => import('@/views/components/ShareSocialMedia.vue')
    },
  methods: {
	qurbanLink() {
		return `${process.env.VUE_APP_FE}/qurban/view/${this.$route.params.slug_and_id}`;
	},
	qurbanName() {
		if(this.data) {
			return this.data.name;
		}

		return 'qurban';
	},
	qurbanDescription() {
		if(this.data && this.data.deskripsi) {
			return this.truncateString( this.replaceText(this.data.deskripsi.replace(/<\/?[^>]+(>|$)/g, "")), 20 );
		}

		return '';
	},
	getAnimalName(type) {
		if([sapiCode, '1'].includes(type)) {
			return 'sapi';
		}
		else {
			return 'kambing';
		}
	},
	getCheckout() {
		let link = `/qurban/checkout/${this.$route.params.slug_and_id}`;

		if(this.$route.query.m) {
			link += `?m=${this.$route.query.m}`;
		}

		if(this.$route.params.referal) {
			link += this.$route.query.m ? `&ref=${this.$route.params.referal}` : `?ref=${this.$route.params.referal}`;
		}

		this.$router.push(link);
	},
    imageLink (qurban) {
      if (qurban.file && qurban.file != null) {
        return `${process.env.VUE_APP_STORAGE}/${qurban.file}`;
      }
				
      return defaultImage;
    },
    donationPercent (qurban) {
      return Math.ceil((parseInt(qurban.donasi_terkumpul) / parseInt(qurban.donasi)) * 100)
    },
    remainDay (qurban) {
      const mulai = new Date(qurban.mulai),
        selesai = new Date(qurban.selesai),
        timeDifferent = selesai.getTime() - mulai.getTime(),
        dayMilsec = 1000 * 60 * 60 * 24

      return timeDifferent / dayMilsec
    },
    back () {
      this.$router.go(-1)
    },
	getQurban() {
		// get id from slug
		const arrSlug = this.$route.params.slug_and_id.split('-'),
				id = Buffer.from(arrSlug[ arrSlug.length - 1 ], 'base64').toString()

		// Check if exist in state
		this.$store.dispatch('qurban/getDetail', id)
		.then(qurban => {
			if(!qurban.donatur_doa) {
				qurban.donatur_doa = [];
			}
			Object.assign(this.data, qurban);
			this.data.deskripsi = this.replaceText(this.data.deskripsi);
			
			this.data.file_user_url = null;
			if(this.data.user && this.data.user.file !== null) {
				this.data.file_user_url = process.env.VUE_APP_STORAGE + '/' + this.data.user.file;
			}

			// Update open grap meta
			let link = `${process.env.VUE_APP_FE}/qurban/view/${this.$route.params.slug_and_id}`;
			let name = this.data ? this.data.name : 'Qurban';
			if(this.$route.params.referal) {
				link += `/${this.$route.params.referal}`;
			}

			meta[0].content = link;
			meta[2].content = this.data ? this.data.name : 'Qurban';
			meta[3].content = this.imageLink(qurban);
			meta[4].content = this.qurbanDescription();
			
			// Update meta via DOM
			const titleNodeList = document.querySelectorAll('meta[property="og:title"]'),
				titleArray = [...titleNodeList],
				urlNodeList = document.querySelectorAll('meta[property="og:url"]'),
				urlArray = [...urlNodeList],
				descNodeList = document.querySelectorAll('meta[property="og:description"]'),
				descArray = [...descNodeList],
				imgNodeList = document.querySelectorAll('meta[property="og:image"]'),
				imgArray = [...imgNodeList];
			
			titleArray.forEach(meta => meta.setAttribute('content', name));
			urlArray.forEach(meta => meta.setAttribute('content', link));
			descArray.forEach(meta => meta.setAttribute('content', this.qurbanDescription()));
			imgArray.forEach(meta => meta.setAttribute('content', this.imageLink(qurban)));
		})
		.catch(e => {
			console.error(e);
			// this.$router.push('/404-notfound')

			return false;
		})
	},
    getOtherQurban() {
		const params = {
			length: 9,
			ord: 'desc',
			status: 1
		};

        this.$store.dispatch('qurban/getOtherQurban', params)
        .catch(e => console.error(e));
    }
  },
  data: () => ({
    PMRole,
    data: {
		penerima_manfaat: [],
		title: '',
		name: ''
	}
  }),
  computed: {
	sapiCode() {
		return sapiCode;
	},
    ...mapState('auth', ['profile']),
	...mapState('qurban', ['otherQurbans'])
  },
  created () {
	this.getQurban()
    this.getOtherQurban()
  }
}
</script>
<style>
	#campaign-card .vx-card{
		box-shadow: none;
		border: 1px solid #ccc;
	}
</style>